__turbopack_context__.v({
  "className": "libre_baskerville_c8904865-module__OZoycq__className",
});
